let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5UJe9")).then(() => parcelRequire('dh9Op'));